export var FOREGROUND_COLOR = 'neutral90';
export var FONT_SIZE = 'T200';
export var PADDING_HORIZONTAL = 'S200';
export var PADDING_VERTICAL = 'S100';
export var DISMISS_BUTTON_GAP = 'S200';
export var DEFAULT_HEIGHT = 32;
export var defaultProps = {
  backgroundColor: 'neutral10',
  dismissButtonAltText: 'Remove'
};